module.exports = __webpack_public_path__ + "img/image-example2.c0328846.png";